import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Redireciona para a página principal após 3 segundos
        const timer = setTimeout(() => {
            navigate('/', { replace: true });
        }, 3000);

        // Cleanup do timer se o componente for desmontado
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="error-page d-flex align-items-center justify-content-center min-vh-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6 text-center">
                        <div className="error-content">
                            <h1 className="error-title mb-4" style={{ fontSize: '6rem', color: '#5236FF' }}>404</h1>
                            <h2 className="mb-3">Página não encontrada</h2>
                            <p className="mb-4 text-muted">
                                A página que você está procurando não existe ou foi movida.
                                Você será redirecionado para a página principal em alguns segundos...
                            </p>
                            <div className="d-flex justify-content-center align-items-center mb-4">
                                <div className="spinner-border text-primary me-3" role="status">
                                    <span className="visually-hidden">Carregando...</span>
                                </div>
                                <span>Redirecionando...</span>
                            </div>
                            <button 
                                onClick={() => navigate('/', { replace: true })}
                                className="btn btn-primary btn-lg"
                                style={{ backgroundColor: '#5236FF', borderColor: '#5236FF' }}
                            >
                                Ir para Página Principal
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound; 